/**
 * This method is for slide in elements when visible to the DOM
 * @param {*} targetElements: Element to animate
 * @param {*} animatePerColumn: Animate per child column
 * @param {*} childElements: Columns to animate
 */

export function animateOnScroll(targetElements, animatePerColumn = false, childElements = null) {
  if ($(targetElements)[0]) {
    const elements = $(targetElements);
    Array.from(elements).forEach((element) => {
      let observer = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              if (animatePerColumn && childElements) {
                Array.from(childElements).forEach((childElement, index) => {
                  childElement.classList.add(
                    'animate__animated',
                    'animate__fadeInUp',
                    `animate__delay-` + (index + 0) + `s`
                  );
                  observer.unobserve(entry.target);
                });
              } else {
                entry.target.classList.add('animate__animated', 'animate__fadeInUp');
                observer.unobserve(entry.target);
              }
            }
          });
        },
        {
          threshold: 0.1,
        }
      );

      observer.observe(element);
    });
  }
}
